import React from 'react'
import './Experience.css'
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";


const Experiense = () => {
    return (
        <section id='experiense'>
            <h5 data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="650"
                data-aos-offset="170" >What Skills I Have</h5>
            <h2 data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="850"
                data-aos-offset="170">My Experience</h2>

            <div className="Econtainer">
                <div className="exper__container">
                    <div data-aos="fade-down"
                        data-aos-easing="linear"
                        data-aos-duration="650"
                        data-aos-offset="200" className="exper__design">
                        <h3>UI/UX Design</h3>
                        <div className="exper__content">
                            <article className='exper__details'>
                                <IoCheckmarkDoneCircleSharp className='exper__details-icon ' />
                                <div>
                                    <h4>Photoshop</h4>
                                    <small className='text-light'>intermediate</small>
                                </div>
                            </article>
                            <article className='exper__details'>
                                <IoCheckmarkDoneCircleSharp className='exper__details-icon ' />
                                <div>
                                    <h4>Adobe Illustrator</h4>
                                    <small className='text-light'>Basic</small>
                                </div>
                            </article><article className='exper__details'>
                                <IoCheckmarkDoneCircleSharp className='exper__details-icon ' />
                                <div>
                                    <h4>Adobe XD</h4>
                                    <small className='text-light'>intermediate</small>
                                </div>
                            </article><article className='exper__details'>
                                <IoCheckmarkDoneCircleSharp className='exper__details-icon ' />
                                <div>
                                    <h4>Figma</h4>
                                    <small className='text-light'>intermediate</small>
                                </div>
                            </article>
                            <article className='exper__details'>
                                <IoCheckmarkDoneCircleSharp className='exper__details-icon ' />
                                <div>
                                    <h4>Microsoft Office</h4>
                                    <small className='text-light'>intermediate</small>
                                </div>
                            </article>
                        </div>
                    </div>
                    {/* ------------------End Of Design------------------- */}
                    <div data-aos="fade-up"
                        data-aos-easing="linear"
                        data-aos-duration="650"
                        data-aos-offset="200" className="exper__frontend">
                        <h3>Fornt-End Development</h3>
                        <div className="exper__content">
                            <article className='exper__details'>
                                <IoCheckmarkDoneCircleSharp className='exper__details-icon ' />
                                <div>
                                    <h4>HTML</h4>
                                    <small className='text-light'>Experienced</small>
                                </div>
                            </article>
                            <article className='exper__details'>
                                <IoCheckmarkDoneCircleSharp className='exper__details-icon ' />
                                <div>
                                    <h4>CSS</h4>
                                    <small className='text-light'>experienced</small>
                                </div>
                            </article><article className='exper__details'>
                                <IoCheckmarkDoneCircleSharp className='exper__details-icon ' />
                                <div>
                                    <h4>JavaScript</h4>
                                    <small className='text-light'>intermediate</small>
                                </div>
                            </article><article className='exper__details'>
                                <IoCheckmarkDoneCircleSharp className='exper__details-icon ' />
                                <div>
                                    <h4>Bootstrap</h4>
                                    <small className='text-light'>Experienced</small>
                                </div>
                            </article><article className='exper__details'>
                                <IoCheckmarkDoneCircleSharp className='exper__details-icon ' />
                                <div>
                                    <h4>Tailwind</h4>
                                    <small className='text-light'>intermediate</small>
                                </div>
                            </article><article className='exper__details'>
                                <IoCheckmarkDoneCircleSharp className='exper__details-icon ' />
                                <div>
                                    <h4>React</h4>
                                    <small className='text-light'>intermediate</small>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Experiense